export default __webpack_public_path__ + "static/media/oneWayTrip.e5a7f05c.svg";